// import React from "react";
// import { MdOutlineBookmarkBorder, MdOutlineBookmark } from "react-icons/md";
// import {
//   addBookmark,
//   removeBookmark,
// } from "../../redux/actions/currentProfileActions";
// import { useSelector, useDispatch } from "react-redux";
// import { IonIcon } from '@ionic/react';
// import { bookmark, bookmarkOutline } from 'ionicons/icons';
// function BookmarkBtn({ id }) {
//   const { data } = useSelector((state) => state.currentProfile);
//   const dispatch = useDispatch();

//   const remove = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     dispatch(removeBookmark(id));
//   };

//   const add = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     dispatch(addBookmark(id));
//   };

//   return data.bookmarks.some((bookmark) => bookmark._id === id) ? (
//     <button
//       onClick={remove}
//       className="display-flex align-items-c post-btns__btn post-btns__bookmark--active"
//     >
//       <MdOutlineBookmark />
//     </button>
//   ) : (
//     <button
//       onClick={add}
//       className="display-flex align-items-c post-btns__btn post-btns__bookmark"
//     >
//       <MdOutlineBookmarkBorder />
//     </button>
//   );
// }

// export default BookmarkBtn;
import React from "react";
import { IonButton, IonIcon } from "@ionic/react";
import { bookmark, bookmarkOutline } from "ionicons/icons";
import {
  addBookmark,
  removeBookmark,
} from "../../redux/actions/currentProfileActions";
import { useSelector, useDispatch } from "react-redux";

function BookmarkBtn({ id }) {
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();

  const isBookmarked = data?.bookmarks?.some((bookmark) => bookmark._id === id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    isBookmarked ? dispatch(removeBookmark(id)) : dispatch(addBookmark(id));
  };

  return (
    <IonButton
      fill="clear"
      size="small"
      shape="round"
      onClick={handleClick}
      className="sidebar-icon display-flex align-items-c post-btns__btn post-btns__reply no-padding-btn"
    >
      <IonIcon
        icon={isBookmarked ? bookmark : bookmark}
        style={{
          width: "30px",
          height: "30px",
          color: isBookmarked ? "#d80621" : "rgba(255, 255, 255, 0.9)",
        }}
      />
    </IonButton>
  );
}

export default BookmarkBtn;
